<template>
  <div class='edit-icon-wrap'>
    <div class='basic-information'>
      <h1>基本信息</h1>
      <div class='name-wrap'>
        <div class='label'>ICON名称</div>
        <div><input type="text" class='input' v-model='name'></div>
      </div>
      <div class='upload-wrap'>
        <div class='label'>头像</div>
        <div class="button-wrap">
          <span class="button is-primary" id="avatarUploadBtn">上传图片</span>
          <span><span class='red'>建议尺寸：220*218px</span> 只能上传 jpg/png 文件，且不超过 1MB</span>
        </div>
        <div class="img-wrap">
          <image-component :image="avatar.image" :width="200" :compress="1.2"></image-component>
        </div>
      </div>
      <div class='upload-wrap'>
        <div class='label'>封面背景</div>
        <div class="button-wrap">
          <span class="button is-primary" id="backgroundUploadBtn">上传图片</span>
          <span><span class='red'>建议尺寸：750*400px</span> 只能上传 jpg/png 文件，且不超过 1MB</span>
        </div>
        <div class="img-wrap">
          <image-component v-show='bgImage.image' :image="bgImage.image" :width="300" :compress="1.2"></image-component>
        </div>
      </div>
      <div class='category-wrap'>
        <div class='label'>分类</div>
        <div>
          <span class="select">
            <select v-model='categoryId'>
              <option value="-1">不设置分类</option>
              <option v-for='category in categoryList' :value="category.categoryId">{{category.categoryName}}</option>
            </select>
          </span>
        </div>
      </div>
      <div class='brief-wrap'>
        <div class='label'>短介绍</div>
        <limit-input :value.sync='brief' :limit-number='12' :placeholder='"请输入短介绍"'></limit-input>
      </div>
      <div class='brief-wrap'>
        <div class='label'>详细介绍</div>
        <div><textarea name="" id="" cols="100" rows="10" v-model='description'></textarea></div>
      </div>
    </div>
    <div class='other-information'>
      <h1>其他信息</h1>
      <div class='common-wrap'>
        <div class='label'>性别</div>
        <div>
          <span class="select">
            <select v-model='sex'>
              <option value="2">女</option>
              <option value="1">男</option>
              <option value="0">未知</option>
            </select>
          </span>
        </div>
      </div>
      <div class='common-wrap'>
        <div class='label'>生日</div>
        <el-date-picker
          v-model="birthday"
          type="date"
          placeholder="选择日期时间"
          align="right">
        </el-date-picker>
      </div>
      <div class='common-wrap'>
        <div class='label'>年龄</div>
        <div><input type="text" class='input' v-model='age' readonly="readonly"></div>
      </div>
      <div class='common-wrap'>
        <div class='label'>星座</div>
        <div><input type="text" class='input' v-model='constellation'></div>
      </div>
      <div class='common-wrap'>
        <div class='label'>身高</div>
        <div><input type="text" class='input' v-model='height'></div>
      </div>
      <div class='common-wrap'>
        <div class='label'>所在地</div>
        <div><input type="text" class='input' v-model='location'></div>
      </div>
    </div>
    <div class='account-setting'>
      <h1>账户设置
        <el-tooltip content='开关开启表示该ICON的动态进入该信息流' placement="right" >
          <span class='cursor-point ' ><i class='fa fa-question-circle fontSize'></i></span>
        </el-tooltip>
      </h1>
      <div v-if='dataReady || !bloggerId'>
          <div>
            <span  class='label inline-block r-top'>推荐频道</span>
            <el-switch
              v-model="isCheckedChannel"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
            <span  class='label inline-block r-top'>标签集合页</span>
            <el-switch
              v-model="isCheckedTagList"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
            <span  class='label inline-block r-top'>其他频道</span>
            <el-switch
              v-model="isCheckedOtherChannel"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
            <span  class='label inline-block r-top'>搜索</span>
            <el-switch
              v-model="isCheckedSearch"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
            <span  class='label inline-block r-top'>专题</span>
            <el-switch
              v-model="isCheckedTopic"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>

          </div>
      </div>
    </div>
    <div class='account-setting'>
      <h1>ICON状态</h1>
      <el-radio v-model="isClose" :label="0">开启</el-radio>
      <el-radio v-model="isClose" :label="1">关闭</el-radio>
    </div>
    <div class='foot'>
      <button class='button is-primary' @click='doSave'>保存</button>
      <button class='button is-default' @click="goBack">返回</button>
    </div>
  </div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import {formatDate} from 'UTILS/date'
import LimitInput from 'COMMON/limitInput'

export default {
  data () {
    return {
      name: '',
      avatar: {
        image: '',
        width: 0,
        height: 0
      },
      bgImage: {
        image: '',
        width: 0,
        height: 0
      },
      categoryId: 0,
      description: '',
      brief: '',
      sex: 2,
      age: '',
      birthday: '',
      constellation: '',
      height: '',
      location: '',
      show_only_channel: 1, // 推荐频道  1是开0是关
      show_only_tagList: 1, // 标签集合页
      show_only_other_channel: 1, // 其他频道
      show_only_search: 1, // 搜索
      show_only_topic: 1, // 专题
      identity: '',
      categoryList: [],
      sort: 0,
      dataReady: false,
      isCheckedChannel: true,
      isCheckedTagList: true,
      isCheckedOtherChannel: true,
      isCheckedSearch: true,
      isCheckedTopic: true,
      isClose: 0// 0:开启1:关闭
    }
  },
  components: { LimitInput },
  watch: {
    birthday (val) {
      this.age = this.getAge(val)
    },
    isCheckedChannel () {
      if (this.isCheckedChannel) {
        this.show_only_channel = 1
      } else {
        this.show_only_channel = 0
      }
    },
    isCheckedTagList () {
      if (this.isCheckedTagList) {
        this.show_only_tagList = 1
      } else {
        this.show_only_tagList = 0
      }
    },
    isCheckedOtherChannel () {
      if (this.isCheckedOtherChannel) {
        this.show_only_other_channel = 1
      } else {
        this.show_only_other_channel = 0
      }
    },
    isCheckedSearch () {
      if (this.isCheckedSearch) {
        this.show_only_search = 1
      } else {
        this.show_only_search = 0
      }
    },
    isCheckedTopic () {
      if (this.isCheckedTopic) {
        this.show_only_topic = 1
      } else {
        this.show_only_topic = 0
      }
    }
  },
  computed: {
    bloggerId () {
      return this.$route.query.bloggerId
    }
  },
  mounted () {
    this.uploadBackground()
    this.uploadAvatar()
    this.getInitialCategory()

    if (this.bloggerId) {
      let params = {
        bloggerId: this.bloggerId
      }
      HttpRequest.get('/admin.php?method=blogger.getBlogger', params).then(response => {
        this.name = response.data.name
        this.avatar = response.data.avatar.image ? response.data.avatar : this.avatar
        this.bgImage = response.data.bgImage.image ? response.data.bgImage : this.bgImage
        this.categoryId = response.data.categoryId
        this.description = response.data.subData.description
        this.brief = response.data.subData.brief
        this.sex = response.data.sex
        this.age = response.data.age
        if (response.data.birthday) {
          this.birthday = formatDate(response.data.birthday, 'yyyy-MM-dd')
        }
        this.constellation = response.data.constellation
        this.height = response.data.height
        this.location = response.data.location
        this.show_only_channel = response.data.show_only_channel
        this.isCheckedChannel = !!response.data.show_only_channel
        this.show_only_tagList = response.data.show_only_tagList
        this.isCheckedTagList = !!response.data.show_only_tagList
        this.show_only_other_channel = response.data.show_only_other_channel
        this.isCheckedOtherChannel = !!response.data.show_only_other_channel
        this.show_only_search = response.data.show_only_search
        this.isCheckedSearch = !!response.data.show_only_search
        this.show_only_topic = response.data.show_only_topic
        this.isCheckedTopic = !!response.data.show_only_topic
        this.isClose = response.data.isClose
        this.sort = response.data.sort
        this.dataReady = true
      })
    }
  },
  methods: {
    goBack () {
      this.$router.push({
        name: 'cyzsIcon',
        query: {
          page: this.$route.query.page,
          selectedBlogger: this.$route.query.selectedBlogger,
          activeIndex: this.$route.query.activeIndex,
          categoryId: this.$route.query.categoryId
        }
      })
    },
    deleteIcon () {
      if (confirm('确定删除吗?')) {
        let params = {
          bloggerId: this.bloggerId
        }
        HttpRequest.get('/admin.php?method=blogger.deleteBlogger', params).then(response => {
          if (response.data.success) {
            this.$message('删除成功')
            setTimeout(() => {
              this.$router.push({
                name: 'cyzsIcon',
                query: {
                  page: this.$route.query.page,
                  selectedBlogger: this.$route.query.selectedBlogger,
                  activeIndex: this.$route.query.activeIndex,
                  categoryId: this.$route.query.categoryId
                }
              })
            }, 2000)
          }
        })
      }
    },
    setIconStatus () {
      this.isClose = this.isClose ? 0 : 1
      let params = {
        bloggerId: this.bloggerId,
        isClose: this.isClose
      }
      HttpRequest.get('/admin.php?method=blogger.setIconStatus', params, true).then(response => {
        if (!response.result) {
          this.$message('修改成功')
        } else {
          this.$message(response.msg)
        }
      })
    },
    getInitialCategory () {
      HttpRequest.get('/admin.php?method=blogger.getIconCategoryList').then(response => {
        this.categoryList = response.data
      })
    },
    doSave () {
      if (!this.name) {
        this.$message('请填写Icon名称')
        return
      }
      let params = {
        name: this.name,
        avatar: this.avatar,
        bgImage: this.bgImage,
        categoryId: this.categoryId,
        description: this.description,
        brief: this.brief,
        sex: this.sex,
        age: this.age,
        birthday: formatDate(new Date(this.birthday).getTime(), 'yyyy-MM-dd'),
        constellation: this.constellation,
        height: this.height,
        location: this.location,
        show_only_channel: this.show_only_channel,
        show_only_tagList: this.show_only_tagList,
        show_only_other_channel: this.show_only_other_channel,
        show_only_search: this.show_only_search,
        show_only_topic: this.show_only_topic,
        sort: this.sort,
        isClose: this.isClose
      }
      if (this.$route.query.bloggerId) {
        params.bloggerId = this.$route.query.bloggerId
      }
      HttpRequest.post('/admin.php?method=blogger.doSaveBlogger', params).then(response => {
        this.$message('保存成功')
        setTimeout(() => {
          this.$router.push({
            name: 'cyzsIcon',
            query: {
              page: this.$route.query.page,
              selectedBlogger: this.$route.query.selectedBlogger,
              activeIndex: this.$route.query.activeIndex,
              categoryId: this.$route.query.categoryId
            }
          })
        }, 2000)
      })
    },
    uploadAvatar () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#avatarUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.avatar.image = response.data.images.info.path
            this.avatar.width = response.data.images.info.width
            this.avatar.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    getAge (birthday) {
      let time = formatDate(new Date(birthday).getTime(), 'yyyy-MM-dd')
      let birthdayYear = new Date(time).getFullYear()
      let birthdayMonth = new Date(time).getMonth()
      let birthdayDate = new Date(time).getDate()
      let currentYear = new Date().getFullYear()
      let currentMonth = new Date().getMonth()
      let currentDate = new Date().getDate()
      if ((currentMonth < birthdayMonth || currentMonth == birthdayMonth) && currentDate < birthdayDate) {
        return currentYear - birthdayYear - 1
      } else {
        return currentYear - birthdayYear
      }
    },
    uploadBackground () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#backgroundUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.bgImage.image = response.data.images.info.path
            this.bgImage.width = response.data.images.info.width
            this.bgImage.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    }
  }
}
</script>

<style lang="less" scoped>
  .basic-information, .other-information, .account-setting {
    border: 1px solid #ccc;
    padding: 20px;
    margin-bottom: 30px;
  }
  .fa.fontSize{
    font-size: 30px;
    padding-top: 15px;
  }

  h1 {
    font-size: 36px;
  }
  .upload-wrap {
    .button-wrap {
      margin: 10px 0;
      line-height: 32px;
    }
    .img-wrap {
      min-height: 100px;
    }
  }
  .label {
    margin: 10px 0;
  }
  .switch {
    position: relative;
    top: 15px;
    left: 15px;
  }
  .foot {
    text-align: center;
    margin-bottom: 100px;
    button {
      margin-left: 10px;
    }
  }
</style>
